export default __webpack_public_path__ + "static/media/pswd_ic.d7cc3461.svg";